import { toast, type ToastOptions } from "react-toastify";

import { useTheme } from "@vega-core/context/ThemeContext/ThemeContext";

import { Toast } from "./Toast";
import { type Props as ToastProps } from "./types";

const configuration: ToastProps = {
  closeButton: false,
  icon: false,
  position: "bottom-center",
  className: "w-96",
};

export const useToast = () => {
  const { theme } = useTheme();

  const showToast = (props: ToastProps) => {
    const toastProps = {
      ...configuration,
      ...props,
      theme: theme === "default" || theme === "light" ? "light" : "dark",
    };

    switch (props.variant) {
      case "success":
        toast.success(<Toast {...props} />, toastProps as ToastOptions);
        break;
      case "destructive":
        toast.error(<Toast {...props} />, toastProps as ToastOptions);
        break;
      case "info":
        toast.info(<Toast {...props} />, toastProps as ToastOptions);
        break;
      case "warning":
        toast.warn(<Toast {...props} />, toastProps as ToastOptions);
        break;
      default:
        toast(<Toast {...props} />, toastProps as ToastOptions);
        break;
    }
  };

  return showToast;
};
